import { render, staticRenderFns } from "./VIcon.vue?vue&type=template&id=1a2ac22b&"
import script from "./VIcon.vue?vue&type=script&lang=js&"
export * from "./VIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports